import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { WhyChooseMalMartBlockView } from './WhyChooseMalMartBlockView';

export const WhyChooseMalMart = Node.create({
    name: 'whychoosemalmart',

    group: 'block',

    defining: true,

    isolating: true,

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },

    renderHTML() {
        return [
            'div',
            {
                'data-type': 'whychoosemalmart',
                class: 'whychoosemalmart-block',
            },
            'Why Choose Mal Mart Block'
        ];
    },

    addCommands() {
        return {
            setWhyChooseMalMart:
                () =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(WhyChooseMalMartBlockView);
    },
});